import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RegexService {
    /*
     * Email regex, matching common emails. Ex: abcd@efg.com
     */
    public email: RegExp = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    /*
     * CVR regex, matching 8 numerical digits. Ex: 12345678
     */
    public cvr: RegExp = /^[0-9]{8}$/;

    /*
     * Phone regex, matching 8 or more numerical digits, optionally with a + for country code. Ex: 20203030 or +4520203030
     */
    public phoneNumber: RegExp = /^\+?\d{8,}$/;

    /**
     * 4 digits. Ex: 2300
     */
    public zipCode: RegExp = /^\d{4}$/;

    /**
     * Date in DD/MM/YYYY format.
     * Very simple validation, accepts 31/02/1950 even though it's not a real date.
     */
    public date: RegExp = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;

    /**
     * Number between 1-20
     */
    public orderNumber: RegExp = /^[0-9]{1,20}$/;

    public reservationKey =
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;

    /*
     * Price regex, matching price containing digits and/or one comma
     public price: RegExp = /^\d+(,\d{1,2})?$/;
    */

    /*
     * Price regex, matching prices greater than 0
     public priceGreaterThanZero: RegExp = /^(?=.*[1-9])\d*(?:\,\d{1,2})?$/;
    */

    /*
     * Price regex, matching price containing digits and/or one comma
     public priceWithThousandSeparator: RegExp = /^\d{1,3}(.\d{3})*(\,\d+)?$/;
    */

    /*
     * Price regex, matching price containing digits and/or one comma greater than zero
     public priceWithThousandSeparatorGreaterThanZero: RegExp = /^(?=.*[1-9])\d{1,3}(.\d{3})*(\,\d+)?$/;
    */

    /*
     * Price regex, matching price containing digits and/or one comma
     public priceWithPeriod: RegExp = /^\d+(\.\d{1,2})?$/;
    */

    /*
     * Price regex, matching price containing digits and/or one comma
     public priceWithPeriodGreaterThanZero: RegExp = /^(?=.*[1-9])\d*(?:\.\d{1,2})?$/;
    */

    /*
     * Integers regex, matching integers greater than 0
     public integerGreaterThanZero: RegExp = /^[1-9]\d{0,2}$/;
    */

    /*
     * Integers regex, matching integers only
     public integerOnly: RegExp = /^\d{0,3}$/;
    */

    /*
     * Apple Dep regex, matching MDM figures
     public appleDep: RegExp = /^[a-zA-Z0-9]{5,32}$/i;
    */
}
